/* eslint-disable new-cap */
/* eslint-disable camelcase */
import ABCyaPhaser, { Images } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class DepressableButton {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {*} x 
   * @param {*} y 
   * @param {*} upState 
   * @param {*} downState 
   * @param {*} onClick 
   * @param {*} text 
   */
  constructor(scene, x, y, upState, downState, onClick = null, text = null, textInfo = null) {
    this.scene = scene;
    this.upState = upState;
    this.downState = downState;

    this.button = scene.add.container(x, y);
    this.buttonBg = Images.addImage(0,0, upState, this.button);
    ABCyaPhaser.Container.setContainerInteractive(this.button, true);

    if (text) {
      this.text = this.scene.add.bitmapText(-1, -9, 'Nasalization', text, 60).setOrigin(0.5)
        .setTint(0xffffd4)
        .setDropShadow(-3, 0, 0x541c46, 1);
      this.button.add(this.text);
      if (textInfo) {
        ABCyaPhaser.Text.resizeFontToFitWidth(this.text, textInfo.maxWidth, textInfo.maxHeight);
      }
    }

    this.button.on('pointerdown', () => {
      this.buttonBg.setFrame(this.downState);
      if (this.text) {
        this.text.setPosition(-15, 1);
      }
    });
    this.button.on('pointerup', () => {
      this.buttonBg.setFrame(this.upState);
      if (this.text) {
        this.text.setPosition(-1, -9);
      }
      onClick();
    });
    this.button.on('pointerout', () => {
      this.buttonBg.setFrame(this.upState);
      if (this.text) {
        this.text.setPosition(-1, -9);
      }
    });

    this.setTextures(upState, downState);
  }

  setTextures(upState, downState) {
    this.buttonBg.setFrame(upState);
    this.upState = upState;
    this.downState = downState;
  }

  eh_ButtonDown() {
    this.buttonBg.setFrame(this.downState);
  }

  eh_ButtonUp() {
    return new Promise((resolve) => {
      this.buttonBg.setFrame(this.upState);
      this.button.scene.time.addEvent({ delay: 100, callback: () => {resolve();} });
    });
  }
}


